import { render, staticRenderFns } from "./PersonalCerficate.vue?vue&type=template&id=f39eee24&scoped=true&"
import script from "./PersonalCerficate.vue?vue&type=script&lang=js&"
export * from "./PersonalCerficate.vue?vue&type=script&lang=js&"
import style0 from "./PersonalCerficate.vue?vue&type=style&index=0&id=f39eee24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39eee24",
  null
  
)

export default component.exports